<template>
  <aha-modal
    @hide="$emit('hide')"
    title="Take over"
    class="take-over-modal"
  >
    <p class="mb-2">
      At the moment, this presentation is being <strong v-if="presenting">presented</strong><strong v-else>edited</strong> by:
    </p>
    <div class="flex items-center p-2 mb-3 bg-secondary-10">
      <aha-avatar
        class="mr-2 text-lg"
        :name="presentation.TakenOverByUser.name"
        :image="presentation.TakenOverByUser.avatar"
        :id="presentation.TakenOverByUser.id"
        :width="36"
        :height="36"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ presentation.TakenOverByUser.name }}</strong>
        </span>
        <p>{{ presentation.TakenOverByUser.email }}</p>
      </div>
    </div>
    <p>
      Once you take over, they will become a viewer and
      only you will be able to edit and present this presentation.
    </p>
    <template #action>
      <aha-button
        variant="danger"
        @click="$emit('takeOver')"
        :submitting="submitting"
        :disabled="submitting"
      >
        Take over
      </aha-button>
      <aha-link
        has-margin-left
        @click="$emit('hide')"
      >
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    presenting: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
